module.exports = {
	AbstractClassError: require("./AbstractClassError").default,
	AbstractMethodError: require("./AbstractMethodError").default,
	MissingContextError: require("./MissingContextError").default,
	NotSupportedError: require("./NotSupportedError").default,
}


//////////////////
// WEBPACK FOOTER
// ./lib/starling/errors/index.js
// module id = 301
// module chunks = 0